module.exports = __webpack_public_path__ + "img/img_title1.e3c0cd1d.png";